module.exports = __webpack_public_path__ + "img/handshake_icon.5ea5bee8.svg";